export function iws_stopPropagation(oEvent) {
    /// <summary>
    ///  Stop la propagation de l'evenement donne.
    /// </summary>
    /// <param name="e" type="event">evenement a stopper.</param>

    //uiCore.log("iws_stopPropagation ==> stopPropagation");

    if (oEvent) {
        if (oEvent.stopPropagation) oEvent.stopPropagation();
        else oEvent.cancelBubble = true;
        if (oEvent.stopImmediatePropagation) oEvent.stopImmediatePropagation();
    }
}
window.iws_stopPropagation = iws_stopPropagation;

export function iws_preventDefault(oEvent) {
    /// <summary>
    ///  Annule la saisie clavier de l'utilisateur
    /// </summary>
    /// <param name="e" type="event">evenement a stopper.</param>

    //uiCore.log("iws_preventDefault ==> preventDefault");

    if (oEvent.preventDefault) oEvent.preventDefault();
    else oEvent.returnValue = false;
}
window.iws_preventDefault = iws_preventDefault;

export function iws_event(oEvent): any {
    /// <summary>
    ///  Obtient l'evenement courant
    /// </summary>
    /// <param name="oEvent" type="event">evenement a stopper.</param>
    return (window.event ? window.event : oEvent);
}
window.iws_event = iws_event;



export function iws_eventTarget(oEvent) {
    /// <summary>
    ///   Obtient l'element d'origine de l'evenement courant
    /// </summary>
    /// <param name="oEvent" type="event">evenement a stopper.</param>
    return (oEvent.srcElement ? oEvent.srcElement : oEvent.target);
}
window.iws_eventTarget = iws_eventTarget;

    /// <summary>
    ///   Obtient la valeur issue de l'évènement courant
    /// </summary>
    /// <param name="oEvent" type="event">valeur issue de l'évènement.</param>
export function iws_eventWhich(oEvent) {
    return window.event ? window.event : oEvent;
}


/*-- CREATION ---------------------------------------------------------------------------
'- Auteur      : YLAR
'- Date        : 16/04/2013
'- Description :  Methode retournant le nom de la page, la propriété propName n'étant pas supporté par FireFox
'-----------------------------------------------------------------------------------------
'  MOD Dysf:55905 : ajout de tests sur la valeur des indexes
'  --------------------------------------------------------------------------------------*/
export function iws_GetPageName() {
    var sPathName = document.location.pathname
    var iDebFichier = sPathName.lastIndexOf('/') + 1;
    var iDebExtension = sPathName.lastIndexOf('.');
    var sReturn = sPathName;

    if (iDebFichier > 0 && iDebExtension > 0) {
        sReturn = sPathName.substring(iDebFichier, iDebExtension);
    }
    return sReturn;
}
window.iws_GetPageName = iws_GetPageName;

/**
 * Retourne la valeur de la Height de la page
 *
 */
export function isiGetClientHeight(): number {
    return document.documentElement.clientHeight;
}
window.isiGetClientHeight = isiGetClientHeight;

/**
 * Retourne la valeur de la width de la page
 */
export function isiGetClientWidth(): number {
    return document.body.clientWidth;
}
window.isiGetClientWidth = isiGetClientWidth;

/**
 * Définit la width de l'objet obj
 * @param obj
 * @param width
 */
export function isiSetWidth(obj: HTMLElement, width: number) {
    if (obj) {
        obj.style.width = width + "px";
    }
}
window.isiSetWidth = isiSetWidth;

    /// <summary>
    /// Transforme une string contenant une taille en pixels en un entier. Exemple : si on lui donne "2px" elle retourne 2.
    /// </summary>
    /// <param name="s" type="string"> Chaine contenant la taille en pixel.</param>
export function pixToInt(s: string): number {

    //ARAN 30/06/2009 [DEV22618] Si s est vide alors on renvoit 0
    if (s !== "") {
        return parseInt(s, 10);
    }
    else {
        return 0;
    }
}
window.pixToInt = pixToInt;

/**
 * Récupére la valeur top de l'objet obj
 * /
 * @param obj
 */
export function isiGetTop(obj: HTMLElement): number  {
    return pixToInt(obj.style.top);
}
window.isiGetTop = isiGetTop;

/**
 * Définit la valeur Top de l'objet obj
 * 
 * @param obj
 * @param top
 */
export function isiSetTop(obj: HTMLElement, top: number) {
    obj.style.top = top + "px";
}
window.isiSetTop = isiSetTop;

/**
 * Récupére la valeur left de l'objet obj
 *  
 * @param obj
 */
export function isiGetLeft(obj: HTMLElement): number {
    return pixToInt(obj.style.left);
}
window.isiGetLeft = isiGetLeft;

/**
 * Définit la valeur left de l'objet obj
 * @param obj
 * @param left
 */
export function isiSetLeft(obj: HTMLElement, left: number) {
    obj.style.left = left + "px";
}
window.isiSetLeft = isiSetLeft;

/**
 * Récupére la valeur Right de l'objet obj
 * @param obj
 */
export function isiGetRight(obj: HTMLElement): number {
    return pixToInt(obj.style.right);
}
window.isiGetRight = isiGetHeight;

export function isiSetRight(obj: HTMLElement, right: number) {
    obj.style.right = right + "px";
}
window.isiSetRight = isiGetHeight;

/**
 * Retourne la Height de l'objet obj
 * @param obj
 */
export function isiGetHeight(obj: HTMLElement): number {
    return pixToInt(obj.style.height);
}
window.isiGetHeight = isiGetHeight;

/**
 * Définit la valeur de la Height de l'objet obj
 * @param obj
 * @param height
 */
export function isiSetHeight(obj: HTMLElement, height: number) {
    obj.style.height = height + "px";
}
window.isiSetHeight = isiSetHeight;

/**
 * Retourne la valeur de la width de l'objet obj
 * @param obj
 */
export function isiGetWidth(obj: HTMLElement): number {
    return pixToInt(obj.style.width);
}
window.isiGetWidth = isiGetWidth;

/**
 * Défint la valeur du Bottom de l'objet obj
 * @param obj
 */
export function isiGetBottom(obj: HTMLElement): number {
    return pixToInt(obj.style.bottom);
}
window.isiGetBottom = isiGetBottom;

/**
* Affecte la SRC au controle image passe en parametre suivant le DOCOLE specifie.
* @param {String} imgCtrl
* @param {String} nameDocole
* @param {String} typeDocole
* @param {String} baseUrl
*/
export function attPreviewSetSrc(imgCtrl, nameDocole: string, typeDocole: string, baseUrl: string, dataToken: string): string {
    // CEGO - 2008.02.12 - [DYSF:21764] : Affichage de la piece jointe par defaut.
    imgCtrl.style.visibility = "visible";
    imgCtrl.alt = nameDocole;
    const linkTo = attPreviewGetUrl(nameDocole, typeDocole, baseUrl, dataToken);
    const sFileExtension = nameDocole.substring(nameDocole.lastIndexOf(".")).toLowerCase();
    switch (sFileExtension) {
        case ".gif":
        case ".png":
        case ".bmp":
        case ".jpg":
        case ".jpeg":
            imgCtrl.src = linkTo;
            imgCtrl.popable = "yes";
            break;

        case ".sql":
            imgCtrl.src = "../../Images/IsiAttPreview/sql_icon.gif";
            imgCtrl.popable = "no";
            break;
        case ".doc":
        case ".docx":
            imgCtrl.src = "../../Images/IsiAttPreview/doc_icon.gif";
            imgCtrl.popable = "no";
            break;
        case ".xls":
        case ".xlsx":
            imgCtrl.src = "../../Images/IsiAttPreview/xls_icon.gif";
            imgCtrl.popable = "no";
            break;
        case ".ppt":
        case ".pptx":
            imgCtrl.src = "../../Images/IsiAttPreview/ppt_icon.gif";
            imgCtrl.popable = "no";
            break;
        case ".pdf":
            imgCtrl.src = "../../Images/IsiAttPreview/pdf_icon.gif";
            imgCtrl.popable = "no";
            break;

        default:
            imgCtrl.src = "../../Images/IsiAttPreview/Unknown_icon.gif";
            imgCtrl.popable = "no";
            break;
    }
    return linkTo;
}

/**
* Fonction qui retourne l'url d'une pj si modifié à synchroniser avec GetEnclosureUrl fonction pl équivalente.
* @param {String} nameDocole
* @param {String} typeDocole
*/
export function attPreviewGetUrl(nameDocole: string, typeDocole: string, baseUrl: string, dataToken: string): string {
    let sUrl = "";
    switch (typeDocole) {
        case "D":
            if (dataToken) {
                // Pour les pièce jointe sécurisée, le lien est généré coté serveur.
                sUrl = dataToken;
                } else {
                    // ARAN 04/01/2010 [REPORT-DYSF32764] Pour les pieces jointes uploader, 
                    // il faut faire un encodeURIComponent afin de gerer les caractere speciaux.
                sUrl = IsiEscape(baseUrl + encodeURIComponent(nameDocole));
                }
            break;
        case "U":
            sUrl = nameDocole;
            break;
        case "F":
            if (nameDocole.indexOf("file:///") < 0) {
                sUrl = "file:///" + nameDocole.replace(/\\/g, "/");
            } else {
                sUrl = nameDocole;
            }
            break;
    }
    return sUrl;
}
window.iws_AttPreviewGetUrl = attPreviewGetUrl
function IsiEscape(stringToEscape: string): string {
    return stringToEscape.replace(/'/g, "%27")
}
/**
 * Supprime les caractère spéciaux d'un message
 * @param msg
 */
export function formatIsiMsg(msg: string) {
    msg = msg.replace("\r\n", "<br/>");
    msg = msg.replace("\n", "<br/>");
    msg = msg.replace("\r", "<br/>");
    msg = msg.replace("/r/n", "<br/>");
    msg = msg.replace("/n", "<br/>");
    msg = msg.replace("/r", "<br/>");
    return msg;
}
window.formatIsiMsg = formatIsiMsg;

